import React, { useEffect, useState } from "react";
import { PageLayout } from "../components/page-layout";
import { runScraper } from "../services/scraper.service";
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { TableContainer, Paper, List, ListItem, ListItemText, Button, TextField, Alert } from "@mui/material";
import { useSiteVarsFunctions } from "../hooks/use-site-vars-functions";
import { getSiteVarsResource } from "../services/sitevars.service";


export const ScraperPage = () => {
  const { getAllowScrape, getScoresUpdatedTime, formatGameWeek } = useSiteVarsFunctions();
  const scrapingEnabled = getAllowScrape();
  const currentGameWeek = formatGameWeek();
  const scoresUpdatedTime = getScoresUpdatedTime();
  const [lastUpdated, setLastUpdated] = useState("");
  const [scraperRunning, setScraperRunning] = useState(false);
  const [freeTextInput, setFreeTextInput] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  
  const handleRunScraper = async () => {
    setErrorMessage(""); // Clear any previous error messages
    setScraperRunning(true);

    const scoresJson = JSON.parse(freeTextInput);
    if(scoresJson && scoresJson.events && scoresJson.events.length > 0 && scoresJson.elements && scoresJson.elements.length > 500) { 
      let currentWeek = 0;
      for (let i = 0; i < scoresJson.events.length; i++) {
        const event = scoresJson.events[i];
        if (event.is_current === true) {
          currentWeek = event.id;
          break;
        }
      }
      
      // If pre-season, use the upcoming gameweek (is_next === true)
      if (currentWeek === 0) {
        for (let i = 0; i < scoresJson.events.length; i++) {
          const event = scoresJson.events[i];
          if (event.is_next === true) {
            currentWeek = event.id;
            break;
          }
        }
      }
      
      if(currentGameWeek.split(" ")[1] == currentWeek) {
        await runScraper(freeTextInput);
        setLastUpdated(new Date().toLocaleString())
      } else {
        setErrorMessage(`Can't update scores as the tlog game week (${currentGameWeek.split(" ")[1]}) does not match the premier league game week (${currentWeek})`);
      }
    } else {
      setErrorMessage(`The provided FPL data is not valid, please check you have copied it correctly`);
    }
      
    setScraperRunning(false);
  };

  useEffect(() => {
    let isMounted = true;

    
  setLastUpdated(scoresUpdatedTime && scoresUpdatedTime._seconds ? new Date(scoresUpdatedTime._seconds * 1000 + scoresUpdatedTime._nanoseconds / 1000000).toLocaleString() : "Never");


    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <PageLayout>
      {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
      <TableContainer component={Paper}>
      {lastUpdated.length === 0 && (
        <Stack spacing={1}>
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
        </Stack>
      )}
      {lastUpdated.length > 0 && (
        <List dense sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
            <ListItem>
                <ListItemText
                primary="Scraping Enabled"
                secondary={scrapingEnabled ? "Yes" : "No"}
                />
            </ListItem>
            <ListItem>
                <ListItemText
                primary="Current Gameweek"
                secondary={currentGameWeek}
                />
            </ListItem>
            <ListItem>
                <ListItemText
                primary="Last Updated"
                secondary={lastUpdated}
                />
            </ListItem>
            <ListItem>
                <ListItemText
                primary="Instructions"
                secondary={<span>Go to <a href="https://fantasy.premierleague.com/api/bootstrap-static/" target="_blank" rel="noopener noreferrer">https://fantasy.premierleague.com/api/bootstrap-static/</a>, copy the response, and paste it into the FPL Scores text box.</span>}
                />
            </ListItem>
            <ListItem>
                <ListItemText
                primary="FPL Scores"
                />
                <TextField id="free-text-input" label="Enter scores data here" variant="outlined" multiline rows={4} value={freeTextInput} onChange={(e) => setFreeTextInput(e.target.value)} />
            </ListItem>
            <ListItem secondaryAction={
                    <Button variant="contained" disabled={scraperRunning || !scrapingEnabled} onClick={handleRunScraper}>Go</Button>
                }>
                <ListItemText
                primary="Submit Data"
                />
            </ListItem>
        </List>
      )}
      
    </TableContainer>
    </PageLayout>
  );
};
